import React from 'react';
import { AlertCircleIcon, PlugZapIcon } from 'lucide-react';
import type { SubmissionStatus } from '../../hooks/useForm';
type FormStatusProps = {
  status: SubmissionStatus;
  onReset?: () => void;
};

/**
 * Honest submission feedback. No delivery backend is connected yet, so a valid form is
 * NOT reported as sent.
 */
export function FormStatus({
  status,
  onReset
}: FormStatusProps) {
  if (status === 'idle') return null;
  if (status === 'invalid') {
    return <div role="alert" className="flex items-start gap-3 rounded-md border border-danger/30 bg-danger-100 p-4 text-sm text-danger" data-id="element-517" data-mp="1sw5m8nvqttn">
        <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-518" data-mp="3k5u1o4hjx2ij" />
        <p data-id="element-519" data-mp="3o7yr0r0yvczd">Some details need attention. Please review the highlighted fields and try again.</p>
      </div>;
  }
  return <div role="status" className="rounded-md border border-royal/30 bg-royal-100 p-4 text-sm text-midnight" data-id="element-520" data-mp="frvjqmdrnqbk">
      <div className="flex items-start gap-3" data-id="element-521" data-mp="kkyh75lnzjx1">
        <PlugZapIcon className="mt-0.5 h-4 w-4 shrink-0 text-royal" aria-hidden="true" data-id="element-522" data-mp="ckl59kpnrsz1" />
        <div data-id="element-523" data-mp="7lrq7nuq3twr">
          <p className="font-medium" data-id="element-524" data-mp="7m1hrfvf294k">Your details are complete, but they have not been sent.</p>
          <p className="mt-1 text-midnight/80" data-id="element-525" data-mp="mae55ogfujng">
            Online submissions are not yet connected to a secure delivery service, so nothing has been transmitted or stored. Please try
            again once submissions are enabled, or use the contact details on our Contact page when they are published.
          </p>
          {onReset && <button type="button" onClick={onReset} className="mt-3 font-medium text-royal underline underline-offset-2" data-id="element-526" data-mp="r97ingvq6anm">
              Clear form
            </button>}
        </div>
      </div>
    </div>;
}